var _a, _b;
import { __assign } from "tslib";
import { handleActions, combineActions } from 'redux-actions';
import { openUserDropdown, closeUserDropdown, openNotificationsDropdown, closeNotificationsDropdown, toggleNotificationsDropdown, toggleSubmitMenu, openSearchModal, closeSearchModal, toggleSearchModal, showPortfolioTooltip, hidePortfolioTooltip, siteHeaderSearchButtonClicked, fetchLiveNotificationsSettings, fetchLiveNotificationsSettingsSuccess, fetchLiveNotificationsSettingsFailure, saveLiveNotificationsSettings, saveLiveNotificationsSettingsSuccess, saveLiveNotificationsSettingsFailure, resetNewFeedback, toggleBurgerMenuRequested, userLogoutButtonClicked, toggleFeedbackPage, } from './actions';
import { receiveHubMessage } from '../../redux/hub/actions';
import { HubChannel } from '../../redux/hub/types';
import { reduxKey } from './constants';
import { setFirstTimeFlags } from '../../redux/firstTimeFlags';
export var initialState = {
    isSearchModalShown: false,
    isUserDropdownOpen: false,
    isBurgerMenuOpen: false,
    isPortfolioTooltipShown: false,
    isNotificationsDropdownOpen: false,
    hasNotificationsDropdownBeenOpened: false,
    isSubmitMenuOpen: false,
    isLiveNotificationsLoading: false,
    isLoggingOut: false,
    newFeedbackCount: 0,
    liveNotificationsSettings: undefined,
};
var setLiveNotificationsLoading = function (state) {
    return state.liveNotificationsSettings || state.isLiveNotificationsLoading
        ? state
        : __assign(__assign({}, state), { isLiveNotificationsLoading: true, liveNotificationsSettings: undefined });
};
var updateLiveNotificationsSettings = function (state, settings) { return (__assign(__assign({}, state), { isLiveNotificationsLoading: false, liveNotificationsSettings: __assign(__assign({ enabled: false }, settings), { types: __assign({ comments: false, replies: false, mentions: false, activity: false }, settings === null || settings === void 0 ? void 0 : settings.types) }) })); };
var actionHandlers = handleActions((_a = {},
    _a[openSearchModal.toString()] = function (state) { return (__assign(__assign({}, state), { isSearchModalShown: true, isUserDropdownOpen: false, isNotificationsDropdownOpen: false })); },
    _a[closeSearchModal.toString()] = function (state) { return (__assign(__assign({}, state), { isSearchModalShown: false })); },
    _a[toggleSearchModal.toString()] = function (state) { return (__assign(__assign({}, state), { isSearchModalShown: !state.isSearchModalShown })); },
    _a[siteHeaderSearchButtonClicked.toString()] = function (state) { return (__assign(__assign({}, state), { isUserDropdownOpen: false, isNotificationsDropdownOpen: false })); },
    _a[openUserDropdown.toString()] = function (state) { return (__assign(__assign({}, state), { isUserDropdownOpen: true, isNotificationsDropdownOpen: false })); },
    _a[closeUserDropdown.toString()] = function (state) { return (__assign(__assign({}, state), { isUserDropdownOpen: false })); },
    _a[showPortfolioTooltip.toString()] = function (state) { return (__assign(__assign({}, state), { isPortfolioTooltipShown: true })); },
    _a[hidePortfolioTooltip.toString()] = function (state) { return (__assign(__assign({}, state), { isPortfolioTooltipShown: false })); },
    _a[openNotificationsDropdown.toString()] = function (state) {
        if (state.isFeedbackPageOpen) {
            return state;
        }
        return __assign(__assign({}, state), { isNotificationsDropdownOpen: true, hasNotificationsDropdownBeenOpened: true, isUserDropdownOpen: false });
    },
    _a[closeNotificationsDropdown.toString()] = function (state) { return (__assign(__assign({}, state), { isNotificationsDropdownOpen: false })); },
    _a[toggleFeedbackPage.toString()] = function (state) { return (__assign(__assign({}, state), { isFeedbackPageOpen: !state.isFeedbackPageOpen, isNotificationsDropdownOpen: false })); },
    _a[toggleNotificationsDropdown.toString()] = function (state) {
        var isOpen = !state.isNotificationsDropdownOpen;
        return __assign(__assign({}, state), { isNotificationsDropdownOpen: isOpen, hasNotificationsDropdownBeenOpened: isOpen || state.hasNotificationsDropdownBeenOpened });
    },
    _a[toggleSubmitMenu.toString()] = function (state) {
        var isOpen = !state.isSubmitMenuOpen;
        return __assign(__assign({}, state), { isSubmitMenuOpen: isOpen });
    },
    _a[combineActions(fetchLiveNotificationsSettings, saveLiveNotificationsSettings).toString()] = function (state) { return setLiveNotificationsLoading(state); },
    _a[combineActions(fetchLiveNotificationsSettingsFailure, saveLiveNotificationsSettingsFailure).toString()] = function (state) { return updateLiveNotificationsSettings(state); },
    _a[combineActions(fetchLiveNotificationsSettingsSuccess, saveLiveNotificationsSettingsSuccess).toString()] = function (state, action) { return updateLiveNotificationsSettings(state, action.payload); },
    _a[receiveHubMessage.toString()] = function (state, action) {
        switch (action.payload.channel) {
            case HubChannel.NEW_FEEDBACK:
                // Indicate availability of new feedback notifications
                // if the header dropdown has been opened before.
                // If it was never opened, we will get fresh feedback on the first load anyway.
                return __assign(__assign({}, state), { newFeedbackCount: state.hasNotificationsDropdownBeenOpened
                        ? state.newFeedbackCount + 1
                        : 0 });
            default:
                return state;
        }
    },
    _a[resetNewFeedback.toString()] = function (state) { return (__assign(__assign({}, state), { newFeedbackCount: 0 })); },
    _a[toggleBurgerMenuRequested.toString()] = function (state, _a) {
        var isOpenAfter = _a.payload.isOpenAfter;
        return (__assign(__assign({}, state), { isBurgerMenuOpen: isOpenAfter !== null && isOpenAfter !== void 0 ? isOpenAfter : !state.isBurgerMenuOpen }));
    },
    _a[userLogoutButtonClicked.toString()] = function (state) { return (__assign(__assign({}, state), { isLoggingOut: true })); },
    _a[setFirstTimeFlags.toString()] = function (state, _a) {
        var isNetworkbarNotUsed = _a.payload.isNetworkbarNotUsed;
        return (isNetworkbarNotUsed ? __assign(__assign({}, state), { isBurgerMenuOpen: true }) : state);
    },
    _a), initialState);
export default (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
//# sourceMappingURL=reducer.js.map